// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import Router from '@/router'
import Popper from 'popper.js'
import Bootstrap from 'bootstrap'
import Api from '@/api'
import AppHelper from '@/helper'
import jQuery from 'jquery'
import i18n from '@/languages'
import VeeValidate from '@/validator'
import Store from '@/store'
// TODO: add i18n
Vue.config.productionTip = false;


window.AppHelper = AppHelper;
window.$ = jQuery;
window.Api = new Api(process.env.BASE_URL + process.env.API_URL);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router: Router,
    i18n,
    store: Store,
    components: { App },
    template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js